import React from "react";
import API_URL from '../config';
import {
  MDBContainer,
  MDBBtn,
  MDBCol,
  MDBRow,
  MDBCard,
  MDBCardBody,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter
} from "mdbreact";
//import DocsLink from "../components/docsLink";
import axios from 'axios';
import 'jspdf-autotable';
import generarBoletaPDF from './generarBoletaPDF';

//import {  MDBIcon } from 'mdbreact';


class BoletasPago extends React.Component{
  //metodo contructor
  constructor(props){
    super(props)
    this.state = {
      datosPersonales:[],
      periodos:[],
      condicionesLaborales:[],
      planillasTrabajador:[],
      boletapdf:[],
      modal1: false,
      modal2: false,
      modal3: false,
      modal4: false,
      seccionActiva: null,
      cargandoPlanillas: false,
      condicionSeleccionada: false,
      periodoSeleccionado: false,
      periodoActual:'',
      planillaActual:'',
      usuario:'',
      autorizacion:''
    };
  }
  //metodo para mostrar/ocultar seccion inline
  toggleSeccion = (seccion) => () => {
    this.setState(prevState => ({
      seccionActiva: prevState.seccionActiva === seccion ? null : seccion
    }));
  }

  componentDidMount() {
    const loc = this.props.location.state;
    if (loc && loc.fromAdmin) {
      const token = loc.datos && loc.datos[0] ? loc.datos[0].autorizacion : '';
      this.setState({
        usuario: loc.adminUsuario || '',
        autorizacion: token,
        condicionesLaborales: loc.adminCondiciones || [],
        periodoActual: loc.adminPeriodo || '',
        planillaActual: loc.adminPlanilla || ''
      }, () => {
        if (this.state.usuario && this.state.periodoActual && this.state.planillaActual) {
          this.cargarBoletaAdmin();
        }
      });
      return;
    }
    // Flujo normal del trabajador
    if (!loc || !loc.datos || !loc.datos[0]) { console.error('No hay datos de sesión'); return; }
    this.setState({ usuario: loc.datos[0].trabajador, autorizacion: loc.datos[0].autorizacion });
    var miInit = {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': loc.datos[0].autorizacion, 'usuario': loc.datos[0].trabajador }
    };
    Promise.all([
      fetch(API_URL + '/vinculopdf/', miInit),
      fetch(API_URL + '/condicionlaboral/', miInit)
    ])
    .then(([res1, res2]) => Promise.all([res1.json(), res2.json()]))
    .then(([data1, data2]) => this.setState({ datosPersonales: data1, condicionesLaborales: data2 }))
    .catch(console.error);
  }

  cargarBoletaAdmin = () => {
    const miInit = {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ usuario: this.state.usuario, periodo: this.state.periodoActual, tipoplanilla: this.state.planillaActual })
    };
    axios.post(API_URL + '/boletapdf/', miInit)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          this.setState({ boletapdf: response.data, seccionActiva: null });
        }
      }).catch(console.error);

    const miInit2 = {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ usuario: this.state.usuario, periodo: this.state.periodoActual })
    };
    axios.post(API_URL + '/vinculopdfuno/', miInit2)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          this.setState({ datosPersonales: response.data });
        }
      }).catch(console.error);
  }

  //metodo par amostrar modal
  toggle = nr => () => {
    let modalNumber = "modal" + nr;
    this.setState({
      [modalNumber]: !this.state[modalNumber]
    });
  };

  ///////////////////////////////////////////
  //////////////////////////////////////////
  //EVENTO DE CONDICION LABORAL
  listarCondicionLaboral=(event)=>{
    event.preventDefault();  
    


    var miInituno = { 
      method: 'post',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': '99999'
      },
      body: JSON.stringify({
        usuario: this.usuarioDato.value,
     })
     };
    /////////////////////////////////////////////
    const usuarioActuald = event.target.value;
    axios.post(API_URL + '/vinculopdfuno/', miInituno)
        .then((response) => {
          if (response.data && response.data.length > 0) {
          this.setState({ datosPersonales : response.data})
          this.setState({ usuario : usuarioActuald})
	        this.setState({ boletapdf : [], seccionActiva: null})
          this.setState({ planillasTrabajador: [], periodos: [], boletapdf: [], seccionActiva: null, condicionSeleccionada: true, periodoSeleccionado: false, cargandoPlanillas: false})
          // Recargar periodos para el nuevo trabajador
          fetch(API_URL + "/cincoultimosperiodos/", {
            method: "post", credentials: "same-origin", mode: "cors",
            headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/json", "Content-Type": "application/json", "authorization": this.state.autorizacion, "usuario": usuarioActuald }
          })
          .then(res => res.json())
          .then(data => {
            if (data && data.length > 0) this.setState({ periodos: data });
          })
          .catch(err => console.error("Error periodos:", err));
          }
          else{
              this.setState({ planillasTrabajador : []})
          }
        } 
        )
        .catch((error) => {
          console.error('Error al obtener los datos:', error);
        });                                            
  }


  /////////////////////////////////////////////////////
  ////////////////////////////////////////////////////
  //metodo para  recuperar el detalle de las planillas
  acceder=(event)=>{
    if (event && event.preventDefault) event.preventDefault();   
    //console.log('entro a  recuperar detalles de la planilla'); 
    //console.log(this.periodoDato.value);
    //console.log(this.tipoDePlanillaDato.value);
    const planillaActuald = this.tipoDePlanillaDato.value;
    if (!planillaActuald) {
      this.setState({ boletapdf: [], seccionActiva: null });
      return;
    }

    var miInittt = { 
      method: 'post',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': '99999'
      },
      body: JSON.stringify({
        usuario: this.state.usuario,
        periodo: this.periodoDato.value,
        tipoplanilla:this.tipoDePlanillaDato.value
     })
     }; 
    
    //axios.get(API_URL + '/boletapdf/'+ this.state.usuario+'/'+this.periodoDato.value +'/'+this.tipoDePlanillaDato.value+'/')
    axios.post(API_URL + '/boletapdf/', miInittt)
        .then((response) => {
          if (response.data && response.data.length > 0) {
          this.setState({ boletapdf : response.data, seccionActiva: null })
          //this.setState({ planillaActual : planillaActuald})
          }
        }
        )
        .catch((error) => {
          console.error('Error al obtener los datos:', error);
        });   
        //------------------------------------------------------------------------------------------------
        //------------------------------------------------------------------------------------------------
        //-------------------------------------------------------------------------------------------------
          var miInitxxx = { 
                method: 'post',
                credentials: 'same-origin',
                mode: 'cors',
                headers: {
                  'X-Requested-With': 'XMLHttpRequest',
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization': '99999'
                },
                  body: JSON.stringify({
                  usuario: this.state.usuario,
                  periodo: this.periodoDato.value,
              })
               };   
        axios.post(API_URL + '/vinculopdfuno/', miInitxxx)
        .then((response) => {
          if (response.data && response.data.length > 0) {
          this.setState({ datosPersonales : response.data})
          //this.setState({ planillaActual : planillaActuald})
          //console.log(response.data)
          }
        }
        )
        .catch((error) => {
          console.error('Error al obtener los datos:', error);
        });
  }

  // Al seleccionar planilla -> cargar periodos de esa planilla
  seleccionarPlanilla=(event)=>{
    if (event && event.preventDefault) event.preventDefault();
    const tipoplanilla = this.tipoDePlanillaDato.value;
    if (!tipoplanilla) {
      this.setState({ periodos: [], boletapdf: [], seccionActiva: null });
      return;
    }
    this.setState({ boletapdf: [], periodos: [], seccionActiva: null });
    var miInitPeriodos = {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ usuario: this.state.usuario, tipoplanilla: tipoplanilla, autorizacion: this.state.autorizacion })
    };
    axios.post(API_URL + '/periodosporplanilla/', miInitPeriodos)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          this.setState({ periodos: response.data });
        }
      })
      .catch((error) => { console.error('Error al obtener periodos:', error); });
  }

  // Al seleccionar periodo -> cargar detalle de boleta
  seleccionarPeriodo=(event)=>{
    if (event && event.preventDefault) event.preventDefault();
    const periodo = event.target.value;
    if (!periodo) {
      this.setState({ boletapdf: [], seccionActiva: null, periodoSeleccionado: false, cargandoPlanillas: false });
      return;
    }
    this.setState({ boletapdf: [], seccionActiva: null, periodoSeleccionado: true, cargandoPlanillas: true });
    if (this.tipoDePlanillaDato) this.tipoDePlanillaDato.value = '';
    var miInitPlan = { method: "post", credentials: "same-origin", mode: "cors", headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/json", "Content-Type": "application/json", "Authorization": "99999" }, body: JSON.stringify({ periodo: periodo, usuario: this.state.usuario, autorizacion: this.state.autorizacion }) };
    axios.post(API_URL + "/planillastrabajadorperiodo/", miInitPlan).then((response) => { var planillas = (response.data || []).filter(function(s) { return s.value && s.value.trim() !== ''; }); this.setState({ planillasTrabajador: planillas, cargandoPlanillas: false }); }).catch((error) => { console.error("Error planillas:", error); this.setState({ planillasTrabajador: [], cargandoPlanillas: false }); });
  }

////////////////////////////////////////////////////////////////////
///////////////PARA GENERAR PDF ////////////////////////////////////
accederPDF=(event)=>{
  event.preventDefault();
  generarBoletaPDF(
    this.state.boletapdf,
    this.state.datosPersonales,
    this.state.planillasTrabajador,
    this.periodoDato.value,
    this.tipoDePlanillaDato.value
  );
}
////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////

  //metodo render
  render(){
    const hasData = this.state.boletapdf.length > 0;
    return(
      <MDBContainer className="mt-4">
        {/* Título */}
        <div className="d-flex align-items-center mb-4">
          <i className="fas fa-file-invoice-dollar fa-2x mr-3" style={{ color: '#7A1622' }}></i>
          <h4 className="mb-0" style={{ color: '#7A1622', fontWeight: '600' }}>Boletas de Pago</h4>
        </div>

        {/* Card de Filtros */}
        <MDBCard className="mb-4" style={{ borderTop: '3px solid #7A1622' }}>
          <MDBCardBody>
            <h6 className="mb-3" style={{ color: '#555', fontWeight: '600' }}>
              <i className="fas fa-filter mr-2"></i>Filtros de Consulta
            </h6>
            <MDBRow>
              <MDBCol md="12" className="mb-3">
                <label style={{ fontWeight: '500', fontSize: '0.85rem', color: '#555' }}>
                  <i className="fas fa-id-badge mr-1" style={{ color: '#7A1622' }}></i>Condición Laboral
                </label>
                <select className="browser-default custom-select"
                  ref={(input) => this.usuarioDato = input}
                  onChange={this.listarCondicionLaboral.bind(this)}
                  style={{ borderRadius: '8px', border: '2px solid #e0e0e0', padding: '10px 12px', fontSize: '0.85rem', height: '42px' }}
                >
                  <option value="" hidden>-- Seleccione su condición laboral --</option>
                  {this.state.condicionesLaborales.map(select => (
                    <option key={select.trabajador} value={select.trabajador}>{select.nombre}</option>
                  ))}
                </select>
              </MDBCol>
              <MDBCol md="3" className="mb-3">
                <label style={{ fontWeight: '500', fontSize: '0.85rem', color: this.state.condicionSeleccionada ? '#555' : '#bbb' }}>
                  <i className="fas fa-calendar-alt mr-1" style={{ color: this.state.condicionSeleccionada ? '#7A1622' : '#ccc' }}></i>Periodo
                  {!this.state.condicionSeleccionada && <span style={{ fontSize: '0.75rem', color: '#bbb', marginLeft: '6px' }}>(Seleccione condición primero)</span>}
                </label>
                <select className="browser-default custom-select"
                  ref={(input) => this.periodoDato = input}
                  onChange={this.seleccionarPeriodo.bind(this)}
                  disabled={!this.state.condicionSeleccionada || this.state.periodos.length === 0}
                  style={{
                    borderRadius: '8px',
                    border: this.state.condicionSeleccionada ? '2px solid #e0e0e0' : '2px solid #f0f0f0',
                    padding: '10px 12px', fontSize: '0.85rem', height: '42px',
                    backgroundColor: this.state.condicionSeleccionada ? '#fff' : '#f5f5f5',
                    color: this.state.condicionSeleccionada ? '#333' : '#bbb',
                    cursor: this.state.condicionSeleccionada ? 'pointer' : 'not-allowed'
                  }}
                >
                  <option value="" hidden>{this.state.condicionSeleccionada ? '-- Seleccione --' : '-- Bloqueado --'}</option>
                  {this.state.periodos.map(select => (
                    <option key={select.periodo} value={select.periodo}>{select.detalle}</option>
                  ))}
                </select>
              </MDBCol>
              <MDBCol md="9" className="mb-3">
                <label style={{ fontWeight: '500', fontSize: '0.85rem', color: this.state.periodoSeleccionado ? '#555' : '#bbb' }}>
                  <i className="fas fa-file-alt mr-1" style={{ color: this.state.periodoSeleccionado ? '#7A1622' : '#ccc' }}></i>Planilla
                  {!this.state.periodoSeleccionado && <span style={{ fontSize: '0.75rem', color: '#bbb', marginLeft: '6px' }}>(Seleccione periodo primero)</span>}
                  {this.state.cargandoPlanillas && <span style={{ fontSize: '0.75rem', color: '#1565C0', marginLeft: '6px' }}><i className="fas fa-spinner fa-spin mr-1"></i>Cargando...</span>}
                </label>
                <select className="browser-default custom-select"
                  ref={(input) => this.tipoDePlanillaDato = input}
                  onChange={this.acceder.bind(this)}
                  disabled={!this.state.periodoSeleccionado || this.state.cargandoPlanillas}
                  style={{
                    borderRadius: '8px',
                    border: this.state.periodoSeleccionado ? '2px solid #e0e0e0' : '2px solid #f0f0f0',
                    padding: '10px 12px', fontSize: '0.85rem', height: '42px',
                    backgroundColor: this.state.periodoSeleccionado ? '#fff' : '#f5f5f5',
                    color: this.state.periodoSeleccionado ? '#333' : '#bbb',
                    cursor: this.state.periodoSeleccionado && !this.state.cargandoPlanillas ? 'pointer' : 'not-allowed'
                  }}
                >
                  <option value="" hidden>{this.state.cargandoPlanillas ? '-- Cargando planillas... --' : this.state.periodoSeleccionado && this.state.planillasTrabajador.length === 0 ? '-- No cuenta con planillas disponibles --' : this.state.periodoSeleccionado ? '-- Seleccione una planilla --' : '-- Bloqueado --'}</option>
                  {this.state.planillasTrabajador.filter(s => s.value !== "").map(select => (
                    <option key={select.value} value={select.value}>{select.text}</option>
                  ))}
                </select>
              </MDBCol>
            </MDBRow>
          </MDBCardBody>
        </MDBCard>

        <MDBRow>
          {/* Datos del Trabajador */}
          <MDBCol md="4">
            <MDBCard className="mb-4" style={{ borderTop: '3px solid #2E7D32' }}>
              <MDBCardBody>
                <h6 className="mb-3" style={{ color: '#2E7D32', fontWeight: '600' }}>
                  <i className="fas fa-user-tie mr-2"></i>Datos del Trabajador
                </h6>
                <MDBTable striped small style={{ fontSize: '0.8rem' }}>
                  <MDBTableBody>
                    {this.state.datosPersonales.slice(0, 5).map(select => (
                      <tr key={select.descripcion}>
                        <td style={{ fontWeight: '500', color: '#555' }}>{select.descripcion === 'Dni' ? 'DNI' : select.descripcion}</td>
                        <td>{select.nombre}</td>
                      </tr>
                    ))}
                  </MDBTableBody>
                </MDBTable>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>

          {/* Acciones */}
          <MDBCol md="8">
            {/* Boton principal de descarga */}
            <div style={{ marginBottom: '16px' }}>
              <MDBBtn
                                onClick={hasData ? this.accederPDF.bind(this) : undefined}
                disabled={!hasData}
                block
                style={{
                  borderRadius: '10px',
                  margin: 0,
                  fontSize: '0.95rem',
                  padding: '13px',
                  fontWeight: '600',
                  backgroundColor: hasData ? '#7A1622' : '#e8e8e8',
                  color: hasData ? '#ffffff' : '#999',
                  border: hasData ? 'none' : '1px solid #ccc',
                  boxShadow: hasData ? '0 3px 10px rgba(122,22,34,0.2)' : 'none',
                  opacity: 1,
                  cursor: hasData ? 'pointer' : 'not-allowed'
                }}
              >
                <i className="fas fa-file-pdf mr-2" style={{ fontSize: '1.1rem' }}></i>
                Descargar Boleta de Pago
              </MDBBtn>
            </div>

            <MDBCard className="mb-4" style={{ borderTop: '3px solid #1565C0' }}>
              <MDBCardBody>
                <h6 className="mb-3" style={{ color: '#1565C0', fontWeight: '600' }}>
                  <i className="fas fa-tasks mr-2"></i>Consultas
                </h6>
                <div className="d-flex flex-wrap" style={{ gap: '10px' }}>
                  <MDBBtn
                    outline color="info"
                    onClick={this.toggleSeccion('afp')}
                    disabled={!hasData}
                    style={{ borderRadius: '20px', margin: 0 }}
                  >
                    <i className="fas fa-university mr-2"></i>Sist. Pensionario
                  </MDBBtn>
                  <MDBBtn
                    outline color="warning"
                    onClick={this.toggleSeccion('detalle')}
                    disabled={!hasData}
                    style={{ borderRadius: '20px', margin: 0 }}
                  >
                    <i className="fas fa-list-alt mr-2"></i>Detalle
                  </MDBBtn>
                  <MDBBtn
                    outline color="success"
                    onClick={this.toggleSeccion('resumen')}
                    disabled={!hasData}
                    style={{ borderRadius: '20px', margin: 0 }}
                  >
                    <i className="fas fa-chart-bar mr-2"></i>Resumen
                  </MDBBtn>
                  
                </div>
              </MDBCardBody>
            </MDBCard>

        {/* Panel inline AFP / Regimen Pensionario */}
        {this.state.seccionActiva === 'afp' && hasData && (() => {
          const datosAfp = this.state.datosPersonales.filter(f => f.afiliacion === 'Afp');
          const valorAfp = datosAfp.length > 0 ? (datosAfp[0].montoAfiliacion || '').trim() : '';
          let nombreRegimen = '';
          const esONP = valorAfp.toUpperCase() === 'ONP' || valorAfp.toUpperCase() === 'DL.19990';
          const esAfpConDetalle = valorAfp.toUpperCase().startsWith('AFP') && valorAfp.toUpperCase() !== 'AFP' && valorAfp.toUpperCase() !== 'SIN AFP' && valorAfp.toUpperCase() !== 'SIN. AFP';
          const esSinRegimen = valorAfp.toUpperCase() === 'AFP' || valorAfp.toUpperCase() === 'SIN AFP' || valorAfp.toUpperCase() === 'SIN. AFP' || valorAfp === '';
          const esDL20530 = valorAfp.toUpperCase() === 'DL.20530';
          if (esONP) {
            nombreRegimen = 'Decreto Ley 19990 (ONP)';
          } else if (valorAfp.toUpperCase() === 'AFP' || valorAfp.toUpperCase() === 'SIN AFP' || valorAfp.toUpperCase() === 'SIN. AFP' || valorAfp === '') {
            nombreRegimen = 'Sin Regimen Pensionario';
          } else if (esDL20530) {
            nombreRegimen = 'Decreto Ley 20530 (Cedula Viva)';
          } else {
            nombreRegimen = valorAfp;
          }
          const formatLabel = (label) => {
            if (!label) return label;
            const upper = label.trim().toUpperCase();
            if (upper === 'AFP') return null;
            if (upper === 'FONDO PENSIONARIO') return 'Aporte Obligatorio al Fondo de Pensiones';
            if (upper === 'PRIMA DE SEGURO') return 'Prima de Seguros';
            if (upper === 'COMISION') return 'Comision AFP %';
            if (upper === 'TOTAL') return '% Aportacion';
            return label;
          };
          const tieneDatosPensionario = this.state.boletapdf.some(f => f.nomdes && (f.nomdes.toUpperCase().indexOf('AFP') >= 0 || f.nomdes.toUpperCase().indexOf('DL.') >= 0 || f.nomdes.toUpperCase().indexOf('ONP') >= 0));

          // Caso 1: Usuario SIN regimen -> siempre muestra titulo + mensaje
          if (esSinRegimen) {
            return (
              <MDBCard className="mb-4" style={{ borderTop: '3px solid #1565C0' }}>
                <MDBCardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0" style={{ fontWeight: '600' }}>
                      <i className="fas fa-university mr-2" style={{ color: '#1565C0' }}></i>
                      <span style={{ color: '#1565C0' }}>Regimen Pensionario: </span>
                      <span style={{ color: '#E65100' }}>{nombreRegimen}</span>
                    </h6>
                    <MDBBtn color="secondary" size="sm" onClick={this.toggleSeccion('afp')} style={{ borderRadius: '20px', margin: 0 }}>Cerrar</MDBBtn>
                  </div>
                  <div style={{ background: '#FFF3E0', border: '1px solid #FFB74D', borderRadius: '6px', padding: '14px 18px', marginTop: '8px' }}>
                    <p style={{ margin: 0, color: '#E65100', fontSize: '0.9rem', fontWeight: '500' }}>
                      <i className="fas fa-exclamation-circle mr-2"></i>
                      Usted a la fecha no cuenta con ningun regimen pensionario
                    </p>
                  </div>
                </MDBCardBody>
              </MDBCard>
            );
          }

          // Caso 2: Usuario CON regimen + planilla SIN "remuneracion" -> solo mensaje sin titulo
          if (!tieneDatosPensionario) {
            return (
              <MDBCard className="mb-4" style={{ borderTop: '3px solid #1565C0' }}>
                <MDBCardBody>
                  <div className="d-flex justify-content-end mb-3">
                    <MDBBtn color="secondary" size="sm" onClick={this.toggleSeccion('afp')} style={{ borderRadius: '20px', margin: 0 }}>Cerrar</MDBBtn>
                  </div>
                  <div style={{ background: '#FFF3E0', border: '1px solid #FFB74D', borderRadius: '6px', padding: '14px 18px' }}>
                    <p style={{ margin: 0, color: '#E65100', fontSize: '0.9rem', fontWeight: '500' }}>
                      <i className="fas fa-info-circle mr-2"></i>
                      No corresponde un regimen pensionario para el tipo de planilla seleccionado
                    </p>
                  </div>
                </MDBCardBody>
              </MDBCard>
            );
          }

          // Caso 3: Usuario CON regimen + planilla CON "remuneracion" -> titulo + tabla
          return (
              <MDBCard className="mb-4" style={{ borderTop: '3px solid #1565C0' }}>
                <MDBCardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0" style={{ fontWeight: '600' }}>
                      <i className="fas fa-university mr-2" style={{ color: '#1565C0' }}></i>
                      <span style={{ color: '#1565C0' }}>Regimen Pensionario: </span>
                      <span style={{ color: '#E65100' }}>{nombreRegimen}</span>
                    </h6>
                    <MDBBtn color="secondary" size="sm" onClick={this.toggleSeccion('afp')} style={{ borderRadius: '20px', margin: 0 }}>Cerrar</MDBBtn>
                  </div>
                  {esAfpConDetalle && (
                  <div>
                    <p style={{ fontSize: '0.85rem', color: '#555', fontWeight: '500', marginBottom: '10px' }}>
                      Porcentajes (%) de Aportes y Comisiones de la AFP
                    </p>
                    <MDBTable striped small>
                      <MDBTableBody>
                        {this.state.datosPersonales.filter(f => f.afiliacion && f.afiliacion.trim() !== '' && f.montoAfiliacion && f.montoAfiliacion.trim() !== '').map(select => {
                          const label = formatLabel(select.afiliacion);
                          if (label === null) return null;
                          const isPrima = select.afiliacion && select.afiliacion.trim().toUpperCase() === 'PRIMA DE SEGURO';
                          return (
                          <tr key={select.afiliacion}>
                            <td style={{ fontWeight: '500' }}>
                              {isPrima ? (
                                <span>Prima de Seguros <span style={{ fontSize: '0.75rem', color: '#777' }}>(% Remuneracion Bruta Mensual)</span></span>
                              ) : label}
                            </td>
                            <td style={{ color: '#1565C0', fontWeight: '600' }}>{select.montoAfiliacion} %</td>
                          </tr>
                          );
                        })}
                      </MDBTableBody>
                    </MDBTable>
                  </div>
                  )}
                  {esONP && (
                  <div>
                    <MDBTable striped small>
                      <MDBTableBody>
                        {this.state.datosPersonales.filter(f => f.afiliacion && f.afiliacion.trim().toUpperCase() === 'TOTAL').map(select => (
                          <tr key={select.afiliacion}>
                            <td style={{ fontWeight: '500' }}>
                              <span>Aportacion obligatoria ONP <span style={{ fontSize: '0.75rem', color: '#777' }}>(Remuneracion Mensual)</span></span>
                            </td>
                            <td style={{ color: '#1565C0', fontWeight: '600' }}>{select.montoAfiliacion} %</td>
                          </tr>
                        ))}
                      </MDBTableBody>
                    </MDBTable>
                  </div>
                  )}
                  {esDL20530 && (
                  <div>
                    <MDBTable striped small>
                      <MDBTableBody>
                        {this.state.datosPersonales.filter(f => f.afiliacion && f.afiliacion.trim().toUpperCase() === 'TOTAL').map(select => (
                          <tr key={select.afiliacion}>
                            <td style={{ fontWeight: '500' }}>
                              <span>Aportacion obligatoria <span style={{ fontSize: '0.75rem', color: '#777' }}>(Remuneracion mensual)</span></span>
                            </td>
                            <td style={{ color: '#1565C0', fontWeight: '600' }}>{select.montoAfiliacion} %</td>
                          </tr>
                        ))}
                      </MDBTableBody>
                    </MDBTable>
                  </div>
                  )}
                </MDBCardBody>
              </MDBCard>
          );
        })()}
        {/* Panel inline Detalle */}        {this.state.seccionActiva === 'detalle' && hasData && (
              <MDBCard className="mb-4" style={{ borderTop: '3px solid #E65100' }}>
                <MDBCardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0" style={{ color: '#E65100', fontWeight: '600' }}>
                      <i className="fas fa-list-alt mr-2"></i>Detalle de Remuneraciones y Descuentos
                    </h6>
                    <MDBBtn color="secondary" size="sm" onClick={this.toggleSeccion('detalle')} style={{ borderRadius: '20px', margin: 0 }}>Cerrar</MDBBtn>
                  </div>
                  <MDBTable striped small style={{ fontSize: '0.8rem' }}>
                    <MDBTableHead>
                      <tr>
                        <th colSpan={2} style={{ textAlign: 'left', fontWeight: 'bold', color: '#2E7D32' }}>Remuneración</th>
                        <th colSpan={2} style={{ textAlign: 'left', fontWeight: 'bold', color: '#C62828' }}>Descuento</th>
                      </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                      {this.state.boletapdf.map(fila => (
                        ((fila.nomrem !== "" && fila.monrem !== "") &&
                          <tr key={fila.nomrem}>
                            <td>{fila.nomrem}</td>
                            <td style={{ color: '#2E7D32', fontWeight: '600' }}>{fila.monrem}</td>
                            <td>{fila.nomdes}</td>
                            <td style={{ color: '#C62828', fontWeight: '600' }}>{fila.mondes}</td>
                          </tr>
                        )
                      ))}
                    </MDBTableBody>
                  </MDBTable>
                </MDBCardBody>
              </MDBCard>
        )}

        {/* Panel inline Resumen Haber */}
        {this.state.seccionActiva === 'resumen' && hasData && (
              <MDBCard className="mb-4" style={{ borderTop: '3px solid #2E7D32' }}>
                <MDBCardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0" style={{ color: '#2E7D32', fontWeight: '600' }}>
                      <i className="fas fa-chart-bar mr-2"></i>Resumen de Pago
                    </h6>
                    <MDBBtn color="secondary" size="sm" onClick={this.toggleSeccion('resumen')} style={{ borderRadius: '20px', margin: 0 }}>Cerrar</MDBBtn>
                  </div>
                  <MDBTable striped small>
                    <MDBTableBody>
                      {this.state.boletapdf.map(fila => (
                        ((fila.nomfin !== "" && fila.monfin !== "") &&
                          <tr key={fila.nomfin}>
                            <td style={{ fontWeight: '500' }}>{fila.nomfin}</td>
                            <td style={{ color: '#2E7D32', fontWeight: '600' }}>{fila.monfin}</td>
                          </tr>
                        )
                      ))}
                    </MDBTableBody>
                  </MDBTable>
                </MDBCardBody>
              </MDBCard>
        )}

          </MDBCol>
        </MDBRow>

        {/* Modal Vínculo Laboral */}
        <MDBModal isOpen={this.state.modal2} toggle={this.toggle(2)} side position="bottom-left">
          <MDBModalHeader toggle={this.toggle(2)}>
            <i className="fas fa-briefcase mr-2" style={{ color: '#2E7D32' }}></i>Vínculo Laboral
          </MDBModalHeader>
          <MDBModalBody>
            <MDBTable striped small>
              <MDBTableBody>
                {this.state.datosPersonales.map(select => (
                  <tr key={select.item}>
                    <td style={{ fontWeight: '500' }}>{select.item}</td>
                    <td>{select.datos}</td>
                  </tr>
                ))}
              </MDBTableBody>
            </MDBTable>
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn color="secondary" size="sm" onClick={this.toggle(2)} style={{ borderRadius: '20px' }}>Cerrar</MDBBtn>
          </MDBModalFooter>
        </MDBModal>


      </MDBContainer>
    )
  }



}
export default BoletasPago;
